export default __webpack_public_path__ + "static/media/faviconOC.b23f8300.ico";